module.exports = __webpack_public_path__ + "static/img/2718_phase_function_Paper_PointsHejduk_Prediction.594700c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2718_phase_function_Paper_PointsHejduk_Prediction.png
// module id = n6kD
// module chunks = 0